<template>
  <div class="d-flex">
    <v-btn
      v-if="to"
      :to="to"
      :exact="true"
      icon
      class="mr-4 align-self-center"
    >
      <v-icon>arrow_back</v-icon>
    </v-btn>

    <div>
      <h2
        class="display-1"
      >{{ title }}</h2>

      <h3
        class="headline"
        v-if="subtitle"
      >{{ subtitle }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BackTitle',
  props: {
    to: {
      type: Object,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    }
  }
}
</script>
